import React from "react";

const Modal = ({ children, visible, toggle, timeout }) => {
  const closeModal = () => {
    toggle(false);
  };

  if (visible && timeout !== undefined && typeof timeout == "number") {
    setTimeout(() => {
      closeModal();
    }, timeout);
  }

  return (
    <div
      className={`fixed z-40 left-0 top-0 w-full h-full overflow-y-auto bg-opacity-70 bg-blue-darker ${
        visible ? "" : "hidden"
      }`}
      onClick={closeModal}
    >
      <div className="bg-white z-50 p-6 w-11/12 md:w-3/4 md:max-w-screen-sm relative left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <button
          onClick={closeModal}
          className="absolute top-2 right-4 text-30 text-gray-light cursor-pointer"
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
